export default "__VITE_ASSET__D4C1K2q4__"